import React, { useEffect, useState, useRef, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getQuotationOrderDetail,updateQu_ProDetail } from "../../../Utility/Api";
import { numberToWords, AmountInWords } from "../../../Utility/function";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { WarehouseContext } from "../../../Utility/UserContext";
import {MediaUrl} from "../../../Utility/Api";
const QuotationPDF = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [OrderList, setOrderList] = useState([]);
  const [RemarkData, setRemarkData] = useState({});
  const modalContentRef = useRef(null);
  const [selectedLanguage, setSelectedLanguage] = useState("english");
  const { shopItem, UserItem ,showLoader,hideLoader} = useContext(WarehouseContext);
  
  const title = UserItem?.parent_company_name || '';
  console.log("title",title);

  useEffect(() => {
    console.log(state);
    getQuotationOrderList(state);
  }, []);

  const statusMap = {
    0: 'Pending',
    1: 'Approved',
    2: 'Rejected',
  };
  const getQuotationOrderList = async (Quotation) => {
    try {
      const res = await getQuotationOrderDetail(Quotation.quotation_number);
  
      if (res?.data) {
        setOrderList(res.data?.data); // This is your order list
        setRemarkData(res.data?.remark); // ✅ This gets the remark object
      }
    } catch (error) {
      console.error('Error fetching quotation order details:', error);
    }
  };
  
  // const handlePrint = async () => 
  //   {
  //   const manualWidth = 300;
  //   const manualHeight = 280;

  //   const content = modalContentRef.current; // Reference to modal content

  //   if (!content) {
  //     console.error("Modal content not found for printing");
  //     return;
  //   }
  //   showLoader();


  //   try {
  //     const canvas = await html2canvas(content, {
  //       scale: 3,
  //     });

  //     const imgData = canvas.toDataURL("image/png");

  //     const pdf = new jsPDF("p", "mm", "a4");

  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = pdf.internal.pageSize.getHeight();

  //     const xOffset = (pdfWidth - manualWidth) / 2;
  //     const yOffset = (pdfHeight - manualHeight) / 2;

  //     pdf.addImage(imgData, "PNG", xOffset, yOffset, manualWidth, manualHeight);

  //     const pdfBlob = pdf.output("blob");
  //     const pdfUrl = URL.createObjectURL(pdfBlob);

  //     const printWindow = window.open(pdfUrl, "_blank");

  //     if (printWindow) {
  //       printWindow.print();
  //     } else {
  //       console.error("Failed to open the print window");
  //     }

  //     URL.revokeObjectURL(pdfUrl);
  //   } catch (error) {
  //     console.error("Failed to generate or print the PDF:", error);
  //     hideLoader();

  //   }
  //   hideLoader();
  // };

 
  const handlePrint = async () => {
    const content = modalContentRef.current;
   const printSpacer = document.getElementById("printSpacer"); // reference to the margin div
   const visableLanguage = document.getElementById("visable-language"); // reference to the margin div

    if (!content) {
      console.error("Modal content not found for printing");
      return;
    }
  
    if (printSpacer) {
      printSpacer.style.marginTop = "50%";
      printSpacer.style.marginBottom = "10%";
    }
    if(visableLanguage){
      visableLanguage.style.visibility ="hidden";
    }
  
    showLoader();
  
    try {
      const canvas = await html2canvas(content, {
        scale: 2, // Better clarity
        useCORS: true,
      });
  
      const pdf = new jsPDF("p", "mm", "a4");
  
      const pdfWidth = pdf.internal.pageSize.getWidth(); // 210mm
      const pdfHeight = pdf.internal.pageSize.getHeight(); // 297mm
  
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
  
      const imgHeight = (pdfWidth * canvasHeight) / canvasWidth;
      const pageHeightInCanvasPx = (pdfHeight * canvasWidth) / pdfWidth;
  
      let heightLeft = canvasHeight;
      let position = 0;
  
      while (heightLeft > 0) {
        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = canvasWidth;
        pageCanvas.height = Math.min(pageHeightInCanvasPx, heightLeft);
  
        const ctx = pageCanvas.getContext("2d");
        ctx.drawImage(
          canvas,
          0,
          position,
          canvasWidth,
          pageCanvas.height,
          0,
          0,
          canvasWidth,
          pageCanvas.height
        );
  
        const pageData = pageCanvas.toDataURL("image/png");
  
        if (position > 0) pdf.addPage();
  
        pdf.addImage(
          pageData,
          "PNG",
          0,
          0,
          pdfWidth,
          (pageCanvas.height * pdfWidth) / canvasWidth
        );
  
        position += pageHeightInCanvasPx;
        heightLeft -= pageHeightInCanvasPx;
      }
  
      const blob = pdf.output("blob");
      const url = URL.createObjectURL(blob);
      const printWindow = window.open(url, "_blank");
  
      if (printWindow) {
        printWindow.print();
      } else {
        console.error("Failed to open print window");
      }
  
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }finally {
      // Re-hide the content
      if (printSpacer) {
        printSpacer.style.marginTop = "0%";
        printSpacer.style.marginBottom = "0%";
      }
      if (visableLanguage) {
        visableLanguage.style.visibility = "visible";
      }
      
    
    }
  
    hideLoader();
  };
  
  
  
  
  const handleDownload = async () => {
    try {
      const content = modalContentRef.current;

      if (!content) {
        toast.error("Unable to locate content for download.");
        console.error("Modal content not found for PDF download.");
        return;
      }

      const canvas = await html2canvas(content, { scale: 3 });
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const manualWidth = 300;
      const manualHeight = 280;

      const xOffset = (pdfWidth - manualWidth) / 2;
      const yOffset = (pdfHeight - manualHeight) / 2;

      pdf.addImage(imgData, "PNG", xOffset, yOffset, manualWidth, manualHeight);

      pdf.save("invoice.pdf");

      toast.success("Invoice downloaded successfully!");
    } catch (error) {
      toast.error("Failed to download the invoice.");
      console.error("Error generating PDF:", error);
    }
  };

  const componentRef = useRef(null);




  // const handlePrint1 = async () => {
  //   const content = componentRef.current; // Reference to modal content

  //   if (!content) {
  //     console.error("Modal content not found for printing");
  //     return;
  //   }

  //   try {
  //     const canvas = await html2canvas(content, { scale: 3 });
  //     const imgData = canvas.toDataURL("image/png");

  //     // Set custom receipt size: 80mm x 210mm
  //     const pdf = new jsPDF({
  //       orientation: "p",
  //       unit: "mm",
  //       format: [80, 210], // 80mm width, 210mm height
  //     });

  //     const pdfWidth = 80; // Fixed width
  //     const imgWidth = 78; // Slightly smaller for padding
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width; // Keep aspect ratio

  //     let yOffset = 5; // Start with a small margin

  //     // If image is too long, split into multiple pages
  //     if (imgHeight > 210) {
  //       let position = 0;
  //       while (position < imgHeight) {
  //         pdf.addImage(
  //           imgData,
  //           "PNG",
  //           1,
  //           yOffset - position,
  //           imgWidth,
  //           imgHeight
  //         );
  //         position += 210; // Move to next page height
  //         if (position < imgHeight) pdf.addPage();
  //       }
  //     } else {
  //       pdf.addImage(imgData, "PNG", 1, yOffset, imgWidth, imgHeight);
  //     }

  //     const pdfBlob = pdf.output("blob");
  //     const pdfUrl = URL.createObjectURL(pdfBlob);

  //     const printWindow = window.open(pdfUrl, "_blank");

  //     if (printWindow) {
  //       printWindow.onload = () => {
  //         printWindow.print();
  //       };
  //     } else {
  //       console.error("Failed to open the print window");
  //     }

  //     URL.revokeObjectURL(pdfUrl);
  //   } catch (error) {
  //     console.error("Error generating the receipt PDF:", error);
  //   }
  // };

  const handlePrint1 = async () => {
    const content = componentRef.current;
  
    if (!content) {
      console.error("Modal content not found for printing");
      return;
    }
  
    // Show the hidden content just for rendering
    content.style.visibility = "visible";
    content.style.position = "absolute";
    content.style.zIndex = "9999";
    content.style.left = "-9999px"; // move off-screen to prevent visual flicker
  
    try {
      const canvas = await html2canvas(content, { scale: 3 });
      const imgData = canvas.toDataURL("image/png");
  
      const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: [80, 210],
      });
  
      const pdfWidth = 80;
      const imgWidth = 78;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
      let yOffset = 5;
  
      if (imgHeight > 210) {
        let position = 0;
        while (position < imgHeight) {
          pdf.addImage(imgData, "PNG", 1, yOffset - position, imgWidth, imgHeight);
          position += 210;
          if (position < imgHeight) pdf.addPage();
        }
      } else {
        pdf.addImage(imgData, "PNG", 1, yOffset, imgWidth, imgHeight);
      }
  
      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
  
      const printWindow = window.open(pdfUrl, "_blank");
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      } else {
        console.error("Failed to open the print window");
      }
  
      URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.error("Error generating the receipt PDF:", error);
    } finally {
      // Re-hide the content
      content.style.visibility = "hidden";
      content.style.position = "absolute";
      content.style.zIndex = "-1";
      content.style.left = "0";
    }
  };
  

  const total = OrderList.reduce(
    (acc, item) => acc + (item?.price * item?.qty || 0),
    0);
  const discountPercent = parseFloat(state?.discount || 0);
  const discountAmount = (total * discountPercent) / 100;
  const grandTotal = total - discountAmount;

  const HandleReCover = async(item) => {
      const res = await updateQu_ProDetail(item.product_id)
      toast.success("Product Name Added in Product List! ");
      if(res.data){
        getQuotationOrderList(state);
      }
  }
  return (
    <>
      <div className="container d-flex  col-8  justify-content-center pt-2">
        <div className="col-6 d-flex column-gap-3 align-items-center">
        </div>
        <div className="col-6 d-flex column-gap-3 align-items-center justify-content-end">
          <button
            type="button"
            className="btn btn-primary py-1 text-small"
            onClick={handleDownload}
          >
            Download
          </button>
          <button
            type="button"
            className="btn btn-info  py-1 text-small"
            onClick={handlePrint}
          >
            Print
          </button>
          <button
            onClick={handlePrint1}
            type="button"
            className="btn btn-info  py-1 text-small"
          >
            Thermal Print
          </button>
        </div>
      </div>
      <div>
        <div className="container  col-8 bg-white " style={{padding:"6.5%"}}  ref={modalContentRef}>
          {/* dd */}
          <div id="visable-language" className="d-flex justify-content-end">
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="language"
                id="english"
                value="english"
                checked={selectedLanguage === "english"}
                onChange={() => setSelectedLanguage("english")}
              />
              <label className="form-check-label" htmlFor="english">
                English
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="language"
                id="arabic"
                value="arabic"
                checked={selectedLanguage === "arabic"}
                onChange={() => setSelectedLanguage("arabic")}
              />
              <label className="form-check-label" htmlFor="arabic">
                العربية
              </label>
            </div>
          </div>
          {/* Header Section */}
          <div style={{ textAlign: "center", paddingBottom: "5px" }}>
            <img
              src="assets/images/tech_logo.webp"
              alt="Left Logo"
              style={{
                maxHeight: "80px",
                borderBottom: "2px dashed black",
                marginTop: "5px",
              }}
            />
          </div>
          <div
            style={{
              textAlign: "center",
              paddingBottom: "5px",
              borderBottom: "2px solid black",
            }}
          >
            <p style={{ marginTop: "20px", lineHeight: "1.4" }} className="mb-2">
              <div className="fw-bold mb-2">
               P.O. Box 605/512, AL Khoudh Souq, Muscat, Sultanate of Oman
              </div>
              <div className="mb-0">
              Mobile: +968 91120555|E-Mail: sales@toptecno.com |Web: www.toptecno.com
              </div>
            </p>
          </div>
          <div className="text-center fw-bold  mb-3 mt-3 text-bold" style={{fontSize:"12px"}}>
          Finance Code: {state.finance_code} | Payment Terms: {state.payment_terms} | Currency: {state.currency_type} | Approval Status: {statusMap[state.approval_status]}
          </div>
          <div className="row  pb-2 my-2 align-items-stretch">
            <div className="col-6">
              <div className="w-100">
                <table className="table" style={{ border: "1px solid #000", borderCollapse: "collapse", width: "100%" }}
 >
                  {/* <thead className="table-ligt">
                    <tr>
                      <th colSpan="2" className="text-center">
                        {selectedLanguage === "arabic"
                          ? "تفاصيل العميل:"
                          : "Customer Details"}
                      </th>
                    </tr>
                  </thead> */}
                  <tbody>
                    <tr className="">
                      <td className="fw-semibold "  style={{ border: "1px solid #000" }}>
                        {selectedLanguage === "arabic" ? "اسم العميل/الشركة:" : "Customer /Company Name:"}
                      </td>
                      <td
                        className="fw-semibold"
                        style={{ textDecoration: "underline", border: "1px solid #000" }}
                      >
                        {state.customer_name}
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-semibold"  style={{ border: "1px solid #000" }}>
                        {selectedLanguage === "arabic"
                          ? "بريد إلكتروني:"
                          : "E Mail:"}
                      </td>
                      <td
                        className="fw-semibold"
                        style={{ textDecoration: "underline" , border: "1px solid #000"}}
                      >
                        {state.customer_email}
                      </td>
                    </tr>

                    <tr>
                      <td className="fw-semibold"  style={{ border: "1px solid #000" }}>
                        {selectedLanguage === "arabic"
                          ? "الشخص الذي يمكن الاتصال به:"
                          : "Contact Person:"}
                      </td>
                      <td
                        className="fw-semibold"
                        style={{ textDecoration: "underline", border: "1px solid #000" }}
                      >
                     {state.contact_person}
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-semibold"  style={{ border: "1px solid #000" }}>
                        {selectedLanguage === "arabic"
                          ? "العنوان:"
                          : "Address:"}
                      </td>
                      <td
                        className="fw-semibold"
                        style={{ textDecoration: "underline" , border: "1px solid #000"}}
                      >
                        {state.customer_branch}
                      </td>
                    </tr>
                  <tr>
                    <td className="text-start fw-semibold"  style={{ border: "1px solid #000" }}>Quote Expiry Date:</td>
                    <td className="text-start fw-semibold"  style={{ border: "1px solid #000" }}>{state.expiry_date}</td>
                  </tr>
                    <tr>
                      <td className="fw-semibold"  style={{ border: "1px solid #000" }}>
                        {selectedLanguage === "arabic" ? "الهاتف:" : "Phone:"}
                      </td>
                      <td
                          className="fw-semibold"
                        style={{ textDecoration: "underline",  border: "1px solid #000" }}
                      >
                        {state.customer_phone}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-6">
            <div className="w-100">
              <table className="table  text-center align-middle m-0"
                style={{ border: "1px solid #000", borderCollapse: "collapse", width: "100%" }}
                >
                <tbody>
                  <tr className="" >
                    <td className="text-start fw-semibold pb-3"  style={{ border: "1px solid #000" }}>Quotation No:</td>
                    <td className="text-start fw-semibold pb-3"  style={{ border: "1px solid #000" }}>
                      {state.quotation_number}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start fw-semibold pb-3"  style={{ border: "1px solid #000" }}>Quote Issue Date:</td>
                    <td className="text-start fw-semibold pb-3"  style={{ border: "1px solid #000" }}>{state.date}</td>
                  </tr>
            
                  <tr>
                  <td className="text-start fw-semibold"  style={{ border: "1px solid #000" }}>
                      {" "}
                      {selectedLanguage === "arabic"
                          ? "رقم الطلب:"
                          : "Request No:"}
                    </td>
                    <td className="text-start fw-semibold"  style={{ border: "1px solid #000" }}>
                      {" "}
                      {state?.request_number || "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start fw-semibold"  style={{ border: "1px solid #000" }}>Category Type:</td>
                    <td className="text-start fw-semibold"  style={{ border: "1px solid #000" }}>{state?.category_type}</td>
                  </tr>
                  <tr>
                    <td className="text-start fw-semibold"  style={{ border: "1px solid #000" }}>Sales Person:</td>
                    <td className="text-start fw-semibold"  style={{ border: "1px solid #000" }}>{state.sales_person}</td>
                  </tr>
                  <tr>
                    <td className="text-start fw-semibold"  style={{ border: "1px solid #000" }}>Sales Contact:</td>
                    <td className="text-start fw-semibold"  style={{ border: "1px solid #000" }}>{state.sales_contact}</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
          </div>
          <div className="mb-5 mt-3 ms-2">
            <p className="fw-bold my-2">Dear Mr./Ms. {state.contact_person}</p>
            <p className="font-13 mb-1">
              We would like to thank <strong>{state.company_name}</strong> for their continued support
              and confidence shown in our expertise and solution offerings. This
              refers to the above-mentioned subject; we are pleased to submit
              our quotation for your requirement as below.
            </p>
            <p className="font-13 mb-3 mt-3">
            We are confident that our offer will meet with your requirements and look forward to answering any
queries you may have before receiving your valued order. Please feel free to contact the undersigned for
further clarifications if required regarding technical and commercial.
            </p>
            <p className="font-13 mb-1">
            Thanking you and always assuring you of our best services,
                        </p>
          </div>
          {/* Authorized Section */}
          <div className="ms-2 mt-5" >
            <p className="fw-bold my-2">Authorized by:</p>
            <p className="font-13 mb-1">Stamp:</p>
            <img src={MediaUrl+state?.stamp} alt="stamp" style={{width:"180px",height:'100px'}}/>
            {/* <p className="font-13 mb-1">Mob No.: _____________________</p> */}
            <p className="font-13 mb-1">Signature:</p>
            <img src={MediaUrl+state?.sign_image} alt="signature" style={{width:"180px",height:'100px'}}/>
          </div>

          <div  id="printSpacer" style={{ marginTop: "0", marginBottom: "0" }}></div>
          <div class="fw-bold mt-5">1. Price Summary:</div>
          <div
            className="row p-3"
            style={{
              position: "relative",
              overflow: "hidden",
              background: `linear-gradient(to bottom, rgba(255, 255, 255, 90%), rgba(255, 255, 255, 90%)), url(assets/images/tech_logo.webp) no-repeat center center / cover`,
              backgroundSize: "60%",
              backgroundPosition: "center",
            }}
          >
            <table className="table table-bordered text-center align-middle mt-1 mb-0 bg-transparent" style={{border: "1px solid #000"}}>
              <thead className="" >
                <tr className="table-light" >
                  <th className="" style={{border: "1px solid #000"}}>
                    <span>
                      {selectedLanguage === "arabic" ? "الرقم" : "SL No."}
                    </span>
                  </th>
                  <th className="bg-" style={{border: "1px solid #000"}}>
                    <span>
                      {selectedLanguage === "arabic"
                        ? "نموذج المنتج"
                        : "Product Model"}
                    </span>
                  </th>
                  <th className="bg- w-100" style={{border: "1px solid #000"}}>
                    <span>
                      {selectedLanguage === "arabic"
                        ? "وصف السلعة"
                        : "Item Description"}
                    </span>
                  </th>
                  <th className="bg-" style={{border: "1px solid #000"}}>
                    <span>
                      {selectedLanguage === "arabic"
                        ? "التسليم/المهلة الزمنية"
                        : "Delivery/Lead time"}{" "}
                    </span>
                  </th>
                  <th className="bg-" style={{border: "1px solid #000"}}>
                    <span>
                      {selectedLanguage === "arabic" ? "كمية" : "Quantity"}
                    </span>
                  </th>
                  <th className="bg-" style={{border: "1px solid #000"}}>
                    <span>
                      {selectedLanguage === "arabic"
                        ? "سعر الوحدة"
                        : "Unit Price"}{" "}
                    </span>
                  </th>
                  <th className="bg-" style={{border: "1px solid #000"}}>
                    <span>
                      {selectedLanguage === "arabic"
                        ? "السعر الإجمالي"
                        : "Total Price"}{" "}
                    </span>
                  </th>
          
                </tr>
              </thead>
              <tbody>
                {OrderList.map((item, index) => (
                  <tr className="bg-transparent" key={index}>
                    <td className="bg-transparent fw-semibold">{index + 1}</td>
                    <td className="bg-transparent fw-semibold">
                      {item.product_name}
                      <span>
                        {item.shop_id.includes("Pending")?<i className="fa fa-plus text-success" role="button" aria-hidden="true"
                        onClick={()=>HandleReCover(item)}
                        ></i>
                          : ""}</span>
                    </td>
                    <td className="bg-transparent fw-semibold">
                      {item.product_desc || "N/A"}
                    </td>
                    <td className="bg-transparent fw-semibold">
                      {item.delivery_time || "Days / weeks"}
                    </td>
                    <td className="bg-transparent fw-semibold">{item.qty}</td>
                    <td className="bg-transparent fw-semibold">
                      {Number(item.price).toFixed(3)}
                    </td>
                    <td className="bg-transparent fw-semibold">
                      {Number(item.price * item.qty).toFixed(3)}

                    </td>
                  </tr>
                ))}

                {Array(5)
                  .fill()
                  .map((item, index) => (
                    <tr className="bg-transparent" key={index} >
                      <td className="bg-transparent fw-semibold">
                        {OrderList.length + (index + 1)}
                      </td>
                      <td className="bg-transparent fw-semibold"></td>
                      <td className="bg-transparent fw-semibold"></td>
                      <td className="bg-transparent fw-semibold"></td>
                      <td className="bg-transparent fw-semibold"></td>
                      <td className="bg-transparent fw-semibold"></td>
                      <td className="bg-transparent fw-semibold"></td>
                    </tr>
                  ))}

                <tr className="table-light"  >
                  <td colSpan="4" className="" style={{border: "1px solid #000"}}>
                  </td>
                  <td colSpan="2" className="fw-semibold text-center" style={{border: "1px solid #000"}}>
                    {selectedLanguage === "arabic" ? "المجموع الفرعي" : "Sub Total"}
                  </td>
                  <td className=" fw-semibold" style={{border: "1px solid #000"}}>
                    {OrderList.reduce(
                      (acc, item) => acc + (item?.price * item?.qty || 0),
                      0
                    ).toFixed(3)}
                  </td>
                </tr>
                <tr className="table-light" >
                  <td colSpan="4" className="" style={{border: "1px solid #000"}}></td>
                  <td colSpan="2" className=" fw-semibold text-center" style={{border: "1px solid #000"}}>
                    {selectedLanguage === "arabic"
                      ? "مبلغ الخصم"
                      : "Discount Amount"}
                  </td>
                  <td className="fw-semibold" style={{border: "1px solid #000"}}>
                    {/* {OrderList?.reduce(
                      (acc, item) => acc + (item?.price * item?.qty || 0),
                      0
                    ).toFixed(3)} */}
                    {/* {parseFloat(state?.discount || 0).toFixed(3)} */}
                    {parseFloat(discountAmount || 0).toFixed(3)}
                    {/* <td className="fw-bold">- {discountAmount.toFixed(3)}</td> */}
                  </td>
                </tr>
                {/* <tr>
                  <td className="bg-transparent"></td>
                  <td className="bg-transparent"></td>
                  <td className="bg-transparent"></td>
                  <td className="bg-transparent fw-bold text-end">{selectedLanguage === 'arabic' ? 'الخصم' : 'Discount'}</td>
                  <td className="bg-transparent"> */}
                {/* {"" +
                      parseFloat(
                        parseFloat(OrderList?.withoutTax) -
                          parseFloat(OrderList?.priceTotal)
                      )} */}
                {/* {"00.00"} */}
                {/* {state?.discount && state?.sub_total
                      ? "- " +
                      (
                        (parseFloat(state?.sub_total || 0) *
                          parseFloat(state?.discount || 0)) /
                        100
                      ).toFixed(0)
                      : "- 0.00"}
                  </td>
                </tr> */}
                {/* <tr>
                  <td className="bg-transparent"></td>
                  <td className="bg-transparent"></td>
                  <td className="bg-transparent"></td>
                  <td className="bg-transparent fw-bold text-end">{selectedLanguage === 'arabic' ? 'الضريبة' : 'Tax'}</td>
                  <td className="bg-transparent"> */}
                {/* {"+ " + OrderList?.taxAmount} */}
                {/* {"00.00"} */}
                {/* {"+ " +
                      parseFloat(
                        (OrderList?.reduce(
                          (acc, item) =>
                            acc +
                            parseFloat(item.price || 0) *
                            parseFloat(item.qty || 0),
                          0
                        ) *
                          parseFloat(state?.vat || 0)) /
                        100
                      ).toFixed(0)}
                  </td>
                </tr> */}

                {/* <tr>
                  <td className="bg-transparent"></td>
                  <td className="bg-transparent"></td>
                  <td className="bg-transparent"></td>
                  <td className="bg-transparent"></td>
                  <td className="bg-transparent"></td>
                </tr> */}
                <tr className="table-light" >
                  <td  colSpan="4" className="text-start  " style={{border: "1px solid #000"}}>
                    {/* <p className="fw-bold text-start mb-0 w-100 text-wrap">
                      {selectedLanguage === "arabic"
                        ? "المبلغ بالأحرف: "
                        : "Amount In Words: "}
                      <br />
                      {AmountInWords(
                        OrderList?.reduce(
                          (acc, item) => acc + (item.price * item.qty || 0),
                          0
                        )
                      )}
                    </p> */}
                    <p className="fw-bold text-start mb-0 w-100 text-wrap">
                      {selectedLanguage === "arabic"
                        ? "المبلغ بالأحرف: "
                        : "Amount In Words: "}
                      <br />
                      {AmountInWords(grandTotal)}
                    </p>
                  </td>
                  <td  colSpan="2" className=" fw-semibold " style={{border: "1px solid #000"}}>
                    {selectedLanguage === "arabic"
                      ? "الإجمالي الكلي"
                      : "Grand Total"}
                  </td>
                  <td className="fw-semibold" style={{border: "1px solid #000"}}>
                    {/* {OrderList?.reduce(
                      (acc, item) => acc + (item?.price * item?.qty || 0),
                      0
                    ).toFixed(3)} */}
                    {parseFloat(grandTotal || 0).toFixed(3)}
                    {/* <td className="fw-bold">{grandTotal.toFixed(3)}</td> */}

                  </td>

                </tr>
              </tbody>
            </table>
            <table className="table table-bordered text-center align-middle mt-0 bg-transparent d-none"  >
              <tbody className="bg-transparent">
                <tr className="bg-transparent" >
                  <td className="text-start bg-transparent" style={{border: "1px solid #000"}}>
                    <p className="fw-semibold text-start mb-0 w-100">
                      {selectedLanguage === "arabic"
                        ? "المبلغ بالأحرف:"
                        : "Amount In Words:"}
                      {AmountInWords(
                        OrderList?.reduce(
                          (acc, item) => acc + (item.price * item.qty || 0),
                          0
                        )
                      )}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="fw-bold mt-3 mb-3">2. Remarks/Notes:</div>
          <ul className="list-unstyled ms-4" style={{ whiteSpace: 'pre-wrap' }}>
  {RemarkData?.remark
    ? RemarkData?.remark.split('\n').map((remark, index) => (
        <li key={index} className="mb-2">{remark}</li>
      ))
    : <li>No terms specified</li>}
</ul>
          {/* <ul>
          <p>{RemarkData.remark || "No remarks available"}</p>
          </ul> */}
          {/* Terms and Conditions */}
          <div className="fw-bold mt-2 mb-2">3. Terms and Conditions:</div>
          {/* <ul className="" style={{ whiteSpace: 'pre-wrap' }}>
            <span className="mb-5">{RemarkData.terms || "No terms specified"}</span>
          </ul> */}
          <ul className="list-unstyled ms-4" style={{ whiteSpace: 'pre-wrap' }}>
  {RemarkData?.terms
    ? RemarkData?.terms.split('\n').map((term, index) => (
        <li key={index} className="mb-2">{term}</li>
      ))
    : <li>No terms specified</li>}
</ul>

        </div>

          {/* dd start */}
          <div
            style={{ textAlign: "center", position: "absolute", zIndex: -1,visibility:"hidden" }}
          >
            <div
              ref={componentRef}
              style={{
                width: "80mm",
                padding: "10px",
                fontFamily: "monospace",
                border: "1px solid #ddd",
                zIndex: -10000,
              }}
            >
              {/* Header Section */}
              <div
                style={{
                  textAlign: "center",
                  borderBottom: "2px dashed black",
                  paddingBottom: "5px",
                }}
              >
                <img
                  src="assets/images/tech_logo.webp"
                  alt="Left Logo"
                  style={{
                    maxHeight: "30px",
                    paddingBottom: "10px",
                    marginTop: "5px",
          
                  }}
                />
                <p
                  style={{
                    margin: "5px 0",
                    fontSize: "12px",
                    lineHeight: "1.4",
                  }}
                >
                  P.O. Box 605/512, AL Khoudh Souq, Muscat, Sultanate of Oman
                  <br />
                  Mobile: +968 91120555 | Sales@toptecno.com
                  <br />
                  www.toptecno.com
                </p>
              </div>

              {/* Invoice Details */}
              <div
                style={{ padding: "5px 0", borderBottom: "2px dashed black" }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  className="mb-0"
                >
                  {state.quotation_number}
                </p>
                <p
                  style={{
                    margin: "5px 0",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                  className="my-0"
                >
                  {state?.customer_name}
                </p>
                <p
                  style={{ margin: "3px 0", fontSize: "12px" }}
                  className="my-0"
                >
                  {state.customer_branch}
                </p>
                <p
                  style={{ margin: "3px 0", fontSize: "12px" }}
                  className="my-0"
                >
                  Total Products : {OrderList?.length || 0}
                </p>
              </div>

              {/* Product List with Justify Alignment */}
              <div
                style={{ padding: "5px 0", borderBottom: "2px dashed black" }}
              >
                {Array.isArray(OrderList) &&
                  OrderList.map((item, index) => (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "13px",
                      }}
                    >
                      <span>
                        {item.qty} x {item.product_name}
                      </span>
                      <span>{item.price}</span>
                      <span>= {Number(item.price * item.qty).toFixed(3)}</span>
                    </div>
                  ))}
              </div>

              {/* Summary Section */}
              <div
                style={{ padding: "5px 0", borderBottom: "2px dashed black" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  <span>Total:</span>{" "}
                  <span>{parseFloat(state?.total || 0).toFixed(3)}</span>
                </div>
              </div>

              {/* Footer */}
              <div
                style={{
                  textAlign: "center",
                  paddingTop: "5px",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                <p>Thank you! Visit Again</p>
              </div>
            </div>
          </div>
      </div>


      {/* <div className="terms-section">
  <h5>Terms & Conditions</h5>
  <pre style={{ whiteSpace: 'pre-wrap' }}>
    {RemarkData.terms || "No terms specified"}
  </pre>
</div>

<div className="remarks-section">
  <h5>Special Remarks</h5>
  <p>{RemarkData.remark || "No remarks available"}</p>
</div></div> */}
    </>
  );
};

export default QuotationPDF;
